import { render, staticRenderFns } from "./invitationCard.vue?vue&type=template&id=07445e2e&scoped=true&"
import script from "./invitationCard.vue?vue&type=script&lang=js&"
export * from "./invitationCard.vue?vue&type=script&lang=js&"
import style0 from "./invitationCard.vue?vue&type=style&index=0&id=07445e2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07445e2e",
  null
  
)

export default component.exports